export default __webpack_public_path__ + "e26c94d1d539335ce9fbe149fa627847.svg";